import type { IconSvgObject } from './types';

const IterationCwIcon: IconSvgObject = [
  ["path", { d: "M4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10C20 14.4183 16.4183 18 12 18H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.99997 14C7.99997 14 4.00001 16.946 4 18C3.99999 19.0541 8 22 8 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default IterationCwIcon;
